<main class="error-data-layout">

    <div class="left-section">
        <div class="image-wrapper">
            <img src="assets/images/register_one.png" alt="Registro Ilustración" class="desktop-img" />
            <img src="assets/images/register_two.png" alt="Registro Ilustración" class="mobile-img" />
        </div>
    </div>

    <!-- Sección derecha -->
    <div class="right-section">
        <form [formGroup]="searchForm" (ngSubmit)="onSearchSubmit()" class="validate-form">
            <h2>El sistema no ha podido encontrar el usuario especificado. Por favor, verifique los datos ingresados e intente nuevamente.</h2>
            <mat-grid-list cols="2" rowHeight="2:1">
                <mat-grid-tile class="col-input">
                    <mat-form-field appearance="fill" class="form-field">
                        <mat-label>{{ nameFieldSearch}}</mat-label>
                        <input matInput type="text" formControlName="numero_empleado" />
                        <mat-error *ngIf="searchForm.get('numero_empleado')?.hasError('required')">Campo obligatorio</mat-error>
                    </mat-form-field>
                </mat-grid-tile>
                <mat-grid-tile class="col-button">
                    <button mat-raised-button class="btn-validate" type="submit" [disabled]="searchForm.invalid">
                        Validar
                    </button>
                </mat-grid-tile>
            </mat-grid-list>

            <p>¿Ya tienes cuenta? <a href="">Inicia sesión.</a></p>

            <p>
                Al crear tu cuenta, aceptas nuestros <a href="assets/docs/TYC.pdf" target="_blank">Términos y Condiciones</a> y nuestra <a href="assets/docs/aviso-privacidad.pdf" target="_blank">Política
                    de Privacidad</a>.
            </p>
        </form>

    </div>
</main>